import { Injectable, inject } from '@angular/core';
import { InvestigationAuthorizationState } from '../../states/investigation-authorization.state';
import { InvestigationPermission } from '../../../domain/enums/investigation-permission.enum';

/**
 * Use case for checking if the current user has a specific investigation permission.
 * Checks against the permissions stored in InvestigationAuthorizationState.
 */
@Injectable({ providedIn: 'root' })
export class HasInvestigationPermissionUseCase {
  private readonly state = inject(InvestigationAuthorizationState);

  /**
   * Checks if the current user has the specified investigation permission.
   *
   * @param permission - The investigation permission to check
   * @returns True if the user has the permission, false otherwise
   */
  public execute(permission: InvestigationPermission): boolean {
    return this.state.hasPermission(permission);
  }
}
